export const getMainSendRequestParams = ({
  auth,
  method = "read",
  params
}) => {
  const isStandaloneMode = !auth.orgs || Object.keys(auth.orgs).length === 0;
  const apiBaseUrl = isStandaloneMode ? `/orgs/:orgId` : `/ents/:entId/orgs/:orgId`;
  const isUpdateMode = method === "update";
  const inFix = isUpdateMode ? "/:radiusId" : "";
  const apiUrl = `${apiBaseUrl}/sites/:siteId/settings/radiusProfile${inFix}.${method}`;

  const requestParamsConfig = {
    standalone: {
      orgId: auth.realm?.id,
      siteId: auth.sites?.id,
    },
    nonStandalone: {
      entId: auth.realm?.id,
      orgId: auth.orgs?.id,
      siteId: auth.sites?.id,
    },
  };

  const requestParams = isStandaloneMode ? requestParamsConfig["standalone"] : requestParamsConfig["nonStandalone"];
  if (isUpdateMode && params) requestParams.radiusId = params.radiusId;

  return {
    apiUrl,
    requestParams
  };
}

export const getInitTableData = ({
  responseData
}) => {
  return responseData.map(radius => {

    return {
      ...radius,
    }
  })
}

export const getCreateOrUpdateCleanPayload = ({
  selectedRadius,
}) => {

  const payload = {
    data: {
      ...selectedRadius,
    }
  };

  return payload;
}

export const getRemoveCleanPayload = ({
  selectedRadius,
}) => {

  const payload = {
    data: {
      ids: [selectedRadius.id],
    }
  };

  return payload;
}